import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import { Spacer } from '@travelnest/merlin.spacer';
import theme from '@travelnest/merlin.theme';
import { Paragraph } from '@travelnest/merlin.typography';
import React from 'react';

interface IRefreshBookingModalProps {
	onRequestClose: () => any;
}

export const RefreshBookingModal: React.FC<IRefreshBookingModalProps> = ({onRequestClose}) => {
	return <Modal
		title="Refresh booking"
		shouldCloseOnOverlayClick={false}
		onRequestClose={onRequestClose}
		actionRHS={
			<Button
				id="refresh_booking_page"
				onClick={() => window.location.reload()}
				bgColor={theme.colours.success.default}
				color={theme.colours.text.light}
			>
				Refresh
			</Button>}
	>
		<div className="booking_refresh_content">
			<Paragraph>
				Changes will not be saved as the booking has been changed since the last time this booking was loaded.
				Please refresh this page to get the latest state of the booking.
			</Paragraph>
			<Spacer />
			<Paragraph>Any existing changes will be discarded.</Paragraph>
		</div>
	</Modal>;
};
